export default __webpack_public_path__ + "static/char-v-07-jp-eacf977039521a9ef003c4095836b3ce.mp4";